import React, { useEffect, useState } from 'react';
import {
  SettingsPage,
  PageHeader,
  PageTitle,
  SaveSettingsButton,
  SettingsContainer,
  SettingsSidebar,
  SettingsNav,
  SettingsTab,
  TabIcon,
  TabLabel,
  SettingsContent,
  SettingsSectionTitle,
  SettingsGroup,
  SettingItem,
  SettingLabel,
  SettingInput,
  SettingTextarea,
  SettingSelect,
  ToggleSwitch,
  ToggleInput,
  ToggleSlider,
  ChangePasswordButton,
  ThemeOptions,
  ThemeOption,
  ThemeInput,
  ThemePreview,
  ThemeName
} from '../../styles/SettingsStyles';
import Swal from 'sweetalert2';
import { GetSettings, MyAccounts, SaveSettings, UpdateUserPassword } from '../../common/CommonApi';
import { useSelector } from 'react-redux';

const Settings = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [platform_fee, setPlatFormFee] = useState("");
  const [try_n_buy_fee, setTryNBuy] = useState("");
  const [delivery_fee, setDeliveryFee] = useState("");
  const [isVendor, setIsVendor] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const userData = useSelector(state => state.auth)
  const [activeTab, setActiveTab] = useState('security');
  const [settings, setSettings] = useState({
    siteName: 'Ootfit',
    siteDescription: 'Your Fashion Destination yup2',
    currency: 'USD',
    timezone: 'UTC',
    language: 'English',
    notifications: {
      email: true,
      push: false,
      sms: false
    },
    security: {
      twoFactor: false,
      sessionTimeout: 30
    }
  });

  const handleSettingChange = (category, key, value) => {
    setSettings(prev => ({
      ...prev,
      [category]: {
        ...prev[category],
        [key]: value
      }
    }));
  };

  // const tabs = [
  // // { id: 'general', label: 'General', icon: '⚙️' },
  // // { id: 'notifications', label: 'Notifications', icon: '🔔' },

  //   ...(isVendor
  //     ? []
  //     : [{ id: 'appsettings', label: 'App Settings', icon: '⚙️' }]),

  //   { id: 'security', label: 'Security', icon: '🔒' }
  // ];

 const tabs = isLoading
  ? []
  : [
      { id: "security", label: "Security", icon: "🔒" },

      ...(isVendor
        ? []
        : [
            {
              id: "appsettings",
              label: "App Settings",
              icon: "⚙️",
            },
          ]),
    ];
console.log("--->isVendor",isVendor)

  useEffect(() => {
  fetchSettings();
  }, []);

const fetchSettings = async () => {
  try {
    const result = await GetSettings();
    const myAccounts = await MyAccounts();

    setIsVendor(Boolean(myAccounts?.isVendor));

    if (result.data.message === "DATA_FOUND") {
      const settings = result.data.data;

      setPlatFormFee(settings?.platform_fee || "");
      setTryNBuy(settings?.try_n_buy_fee || "");
      setDeliveryFee(settings?.delivery_fee || "");
    }
  } catch (error) {
    console.error("Error fetching settings:", error);

    Swal.fire({
      icon: "error",
      position: "top-end",
      title: "Failed to load settings",
    });
  } finally {
    setIsLoading(false);
  }
};

  const handleChangePassword = async () => {
    // 1️⃣ Validate inputs
    if (!oldPassword || !newPassword || !confirmPassword) {
      Swal.fire({ position: "top-end", title: "All fields are required" });
      return;
    }

    if (newPassword !== confirmPassword) {
      Swal.fire({ position: "top-end", title: "New password and confirm password do not match" });
      return;
    }
    try {
      const data = {
        email: userData.email,
        oldPassword,
        newPassword
      }
      const result = await UpdateUserPassword(data)
      if (result.data.data.message == "INVALID_OLD_PASSWORD") {
        Swal.fire({ icon: "error", position: "top-end", title: 'Old Password is Wrong' });
      }
      if (result.data.data.message == 'PASSWORD_UPDATED_SUCCESSFULLY') {
        Swal.fire({ icon: "success", position: "top-end", title: 'Password Updated Succesfully' });
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      }
      // console.log("--->result",result.data.data.message)

      // 3️⃣ Handle response
      // if (res.data.status) {
      //   Swal.fire("Success", "Password updated successfully", "success");
      //   setOldPassword("");
      //   setNewPassword("");
      //   setConfirmPassword("");
      // } else {
      //   Swal.fire("Error", res.data.message || "Failed to update password", "error");
      // }
    } catch (err) {
      Swal.fire("Error", "Something went wrong", "error");
      console.error(err);
    }
  };

  const handleSaveSettings = async () => {
    try {
      const data = {
        platform_fee: Number(platform_fee),
        try_n_buy_fee: Number(try_n_buy_fee),
        delivery_fee: Number(delivery_fee),
      };

      const result = await SaveSettings(data);
      // console.log("=--result",result.data)
      if (result.data.message == "DATA_FOUND") {
        Swal.fire({
          icon: "success",
          position: "top-end",
          title: "Settings saved successfully",
        });

        // Optional
        // setPlatFormFee("");
        // setTryNBuy("");
        // setDeliveryFee("");
      } else {
        Swal.fire({
          icon: "error",
          position: "top-end",
          title: "Failed to save settings",
        });
      }
    } catch (err) {
      console.error(err);

      Swal.fire({
        icon: "error",
        position: "top-end",
        title: "Something went wrong",
      });
    }
  };

  return (
    <SettingsPage>
      <SettingsContainer>
        <SettingsSidebar>
          <SettingsNav>
            {tabs.map(tab => (
              <SettingsTab
                key={tab.id}
                className={activeTab === tab.id ? 'active' : ''}
                onClick={() => setActiveTab(tab.id)}
              >
                <TabIcon>{tab.icon}</TabIcon>
                <TabLabel>{tab.label}</TabLabel>
              </SettingsTab>
            ))}
          </SettingsNav>
        </SettingsSidebar>

        <SettingsContent>
          {activeTab === 'general' && (
            <div>
              <SettingsSectionTitle>General Settings</SettingsSectionTitle>
              <SettingsGroup>
                <SettingItem>
                  <SettingLabel>Site Name</SettingLabel>
                  <SettingInput
                    type="text"
                    value={settings.siteName}
                    onChange={(e) => setSettings(prev => ({ ...prev, siteName: e.target.value }))}
                  />
                </SettingItem>

                <SettingItem>
                  <SettingLabel>Site Description</SettingLabel>
                  <SettingTextarea
                    value={settings.siteDescription}
                    onChange={(e) => setSettings(prev => ({ ...prev, siteDescription: e.target.value }))}
                    rows="3"
                  />
                </SettingItem>

                <SettingItem>
                  <SettingLabel>Default Currency</SettingLabel>
                  <SettingSelect
                    value={settings.currency}
                    onChange={(e) => setSettings(prev => ({ ...prev, currency: e.target.value }))}
                  >
                    <option value="USD">USD - US Dollar</option>
                    <option value="EUR">EUR - Euro</option>
                    <option value="GBP">GBP - British Pound</option>
                    <option value="INR">INR - Indian Rupee</option>
                  </SettingSelect>
                </SettingItem>

                <SettingItem>
                  <SettingLabel>Timezone</SettingLabel>
                  <SettingSelect
                    value={settings.timezone}
                    onChange={(e) => setSettings(prev => ({ ...prev, timezone: e.target.value }))}
                  >
                    <option value="UTC">UTC</option>
                    <option value="EST">EST - Eastern Time</option>
                    <option value="PST">PST - Pacific Time</option>
                    <option value="IST">IST - India Standard Time</option>
                  </SettingSelect>
                </SettingItem>
              </SettingsGroup>
            </div>
          )}

          {activeTab === 'notifications' && (
            <div>
              <SettingsSectionTitle>Notification Settings</SettingsSectionTitle>
              <SettingsGroup>
                <SettingItem>
                  <SettingLabel>Email Notifications</SettingLabel>
                  <ToggleSwitch>
                    <ToggleInput
                      type="checkbox"
                      checked={settings.notifications.email}
                      onChange={(e) => handleSettingChange('notifications', 'email', e.target.checked)}
                    />
                    <ToggleSlider />
                  </ToggleSwitch>
                </SettingItem>

                <SettingItem>
                  <SettingLabel>Push Notifications</SettingLabel>
                  <ToggleSwitch>
                    <ToggleInput
                      type="checkbox"
                      checked={settings.notifications.push}
                      onChange={(e) => handleSettingChange('notifications', 'push', e.target.checked)}
                    />
                    <ToggleSlider />
                  </ToggleSwitch>
                </SettingItem>

                <SettingItem>
                  <SettingLabel>SMS Notifications</SettingLabel>
                  <ToggleSwitch>
                    <ToggleInput
                      type="checkbox"
                      checked={settings.notifications.sms}
                      onChange={(e) => handleSettingChange('notifications', 'sms', e.target.checked)}
                    />
                    <ToggleSlider />
                  </ToggleSwitch>
                </SettingItem>
              </SettingsGroup>
            </div>
          )}

          {activeTab === 'security' && (
            <div>
              <SettingsSectionTitle>Security Settings</SettingsSectionTitle>
              <SettingsGroup>
                {/* <SettingItem>
                    <SettingLabel>Two-Factor Authentication</SettingLabel>
                    <ToggleSwitch>
                      <ToggleInput
                        type="checkbox"
                        checked={settings.security.twoFactor}
                        onChange={(e) => handleSettingChange('security', 'twoFactor', e.target.checked)}
                      />
                      <ToggleSlider />
                    </ToggleSwitch>
                  </SettingItem> */}

                <SettingItem>
                  <SettingLabel>Current Password</SettingLabel>
                  <SettingInput
                    type="password"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    placeholder="Enter current password"
                  />

                  <SettingLabel>New Password</SettingLabel>
                  <SettingInput
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="Enter new password"
                  />

                  <SettingLabel>Confirm New Password</SettingLabel>
                  <SettingInput
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirm new password"
                  />
                </SettingItem>

                <PageHeader>
                  <SaveSettingsButton
                    onClick={handleChangePassword}
                  >💾 Save Changes</SaveSettingsButton>
                </PageHeader>
              </SettingsGroup>
            </div>
          )}
          
          {!isVendor && activeTab === "appsettings" && (
            <div>
              <SettingsSectionTitle>App Settings</SettingsSectionTitle>

              <SettingsGroup>
                <SettingItem>
                  <SettingLabel>Delivery Fee</SettingLabel>
                  <SettingInput
                    type="text"
                    value={delivery_fee}
                    onChange={(e) => setDeliveryFee(e.target.value)}
                    placeholder="Enter Delivery Fee"
                  />
                </SettingItem>

                <SettingItem>
                  <SettingLabel>Platform Fee</SettingLabel>
                  <SettingInput
                    type="text"
                    value={platform_fee}
                    onChange={(e) => setPlatFormFee(e.target.value)}
                    placeholder="Enter Platform Fee"
                  />
                </SettingItem>

                <SettingItem>
                  <SettingLabel>Try n Buy Fee</SettingLabel>
                  <SettingInput
                    type="text"
                    value={try_n_buy_fee}
                    onChange={(e) => setTryNBuy(e.target.value)}
                    placeholder="Enter Try n Buy Fee"
                  />
                </SettingItem>

                <PageHeader>
                  <SaveSettingsButton onClick={handleSaveSettings}>
                    💾 Save Changes
                  </SaveSettingsButton>
                </PageHeader>
              </SettingsGroup>
            </div>
          )}
        </SettingsContent>
      </SettingsContainer>
    </SettingsPage>
  );
};

export default Settings;
